<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "additional_form_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-additional-settings-signal
    [settings]="settings()"
    [addChatBotToForm]="addChatBotToForm()"
    [pages]="pages$ | async"
    [siteDomains]="domains$ | async"
    [baseHref]="baseHref"
    [deviceMode]="selectedDeviceMode$ | async"
    (valueChangeEvent)="onSettingsChange($event)"
/>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
